/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { leftIcon, modalContainer } from "../../theme/commonStyle";
import { Theme } from "@mui/material";

const groupStyle = {
  leftIcon,
  modalContainer,
  question: {
    textAlign: "center",
    fontSize: "1.25rem",
    lineHeight: 1.5,
  },
  input: {
    visibility: "hidden",
  },
  formHelperText: {
    textAlign: "center",
    fontSize: "1rem",
  },
  fieldset: {
    width: "100%",
    alignItems: "center",
  },
  label: (theme: Theme) => ({
    fontSize: "1.25rem",
    color: "#333",
    textAlign: "center",
    padding: "0 1rem",
    lineHeight: 1.5,
    margin: "0 auto",
    ...(theme.palette.mode === "dark"
      ? {
          color: "#F4F4F4",
        }
      : {}),
  }),
};

export default groupStyle;
